import * as React from 'react';

type CarouselImageProps = {
  src: string | null;
}

const CarouselImage = (props: CarouselImageProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const previousImageRef = React.useRef<HTMLDivElement | null>(null);
  const currentImageRef = React.useRef<HTMLDivElement | null>(null);

  const fadeOut = React.useCallback(() => {
    if (!currentImageRef.current) {
      return;
    }

    const element = currentImageRef.current;

    previousImageRef.current = element;
    currentImageRef.current = null;

    element.classList.remove(':fade-in');
    element.classList.add(':fade-out');

    setTimeout(() => {
      element.remove();
    }, 1000);
    return () => {
      element.remove();
    }
  }, [props.src]);

  const fadeIn = React.useCallback(() => {
    if (!props.src || !containerRef.current) {
      return;
    }

    const handleLoad = () => {
      element.classList.add('animate', ':fade-in');
    };

    const image = new Image();
    image.addEventListener('load', handleLoad, { once: true });
    image.src = props.src;

    const element = document.createElement('div');
    element.className = 'course-carousel-image';
    element.style.backgroundImage = `url(${props.src})`;

    containerRef.current.appendChild(element);
    currentImageRef.current = element;

    return () => {
      image.removeEventListener('load', handleLoad);
    };
  }, [props.src]);

  React.useLayoutEffect(() => {
    fadeOut();
    fadeIn();
  }, [props.src])


  return (
    <div
      ref={containerRef}
      className="course-carousel-image-container"
    >
      <svg className="course-carousel-circle" width="341" height="341" viewBox="0 0 341 341" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="170.5" cy="170.5" r="170.5" fill="#F94646" /></svg>
    </div>
  );
};

export default CarouselImage;



// WEBPACK FOOTER //
// ./src/components/CourseCarousel/Image.tsx